import React, { CSSProperties } from 'react';
import {
	CircularProgress,
	Row,
} from '@farmart-engineering/central-component-library';

const Loader = ({ styles }: { styles?: CSSProperties }) => (
	<Row justifyContent='center' alignItems='center' width='100%' height='100%'>
		<CircularProgress size='md' />
	</Row>
);

export default React.memo(Loader);
